import React, { useState } from 'react';
import { Box, Drawer } from '@mui/material';
import { ArrowBackIosNew } from '@mui/icons-material';
import { useLocation, useHistory } from 'react-router-dom';
import useLesson from 'Pages/EditCourse/Hooks/useLesson';
import useTranslation from 'Hooks/useTranslation';
import DragAndDrop from './Containers/DragAndDrop';
import TabPage from './Components/TabPage';
import Module from './Components/Module';
import AddButton from './Components/AddButton';
import useModule from './Hooks/useModule';
import useDragAndDrop from './Hooks/useDragAndDrop';
import useTab from './Hooks/useTab';

import { Main, drawerStyle, boxStyle, HeaderContainer, FloatingBackContainer } from './style';

export default function EditCourse() {
  const { t2 } = useTranslation('EditCourse');
  const location = useLocation();
  const history = useHistory();
  const [courseName, setCourseName] = useState(location?.state?.course[0]);

  const isComingFrom = location?.state?.isComingFrom;

  if (['/cursos', '/cursos/detalles'].includes(isComingFrom) === false) {
    return history.replace('/cursos');
  }

  const courseId = location?.state?.course?.[location?.state?.course?.length - 1];

  const isDraft = location?.state?.course[8];

  const {
    modules,
    setModules,
    deleteModule,
    updateModule,
    updateMultipleModules,
    addModule,
    currentPositionModule,
    setCurrentPositionModule,
    typeContent,
    setTypeContent,
    alert,
    setAlert,
  } = useModule({
    courseId,
  });

  const {
    addLesson,
    addLessonSession,
    addLessonAutoEvaluation,
    updateLesson,
    updateLessonSessionData,
    deleteLesson,
    updateLessonData,
    currentPositionLesson,
    setCurrentPositionLesson,
  } = useLesson({
    modules,
    setModules,
    currentPositionModule,
    setCurrentPositionModule,
    setTypeContent,
    alert,
    setAlert,
  });

  const [open, setOpen] = useState(false);

  const { tabsTitle, pages } = useTab({
    modules,
    deleteModule,
    updateModule,
    currentPositionModule,
    isDraft,
    typeContent,
    addLesson,
    addLessonSession,
    addLessonAutoEvaluation,
    updateLesson,
    updateLessonSessionData,
    courseId,
    currentPositionLesson,
    deleteLesson,
    updateLessonData,
    setCourseName,
    alert,
    setAlert,
    setOpen,
  });

  const { onDragEnd } = useDragAndDrop({
    modules,
    updateMultipleModules,
    updateLesson,
    updateModule,
  });

  return (
    <Box sx={boxStyle}>
      <Drawer sx={drawerStyle} variant="persistent" anchor="left" open={open}>
        <div style={{ height: '90%', overflow: 'scroll' }}>
          <DragAndDrop onDragEnd={onDragEnd} type="Modules">
            {modules.map((module, index) => {
              return (
                <Module
                  key={index}
                  modules={modules}
                  position={index}
                  setCurrentPositionModule={setCurrentPositionModule}
                  setTypeContent={setTypeContent}
                  currentPositionLesson={currentPositionLesson}
                  setCurrentPositionLesson={setCurrentPositionLesson}
                />
              );
            })}
          </DragAndDrop>
        </div>
        <AddButton onClick={addModule} />
      </Drawer>
      <Main open={open}>
        <HeaderContainer>
          <FloatingBackContainer
            onClick={() => {
              // Si viene de la página del detalle de un curso, quiere decir que es administrador
              // y puede editar un curso.
              if (isComingFrom === '/cursos/detalles') {
                return history.replace('/mis-cursos');
              }

              // De lo contrario, viene de la página de "/cursos" que es cuando tambien eres
              // administrador.

              return history.replace('/cursos');
            }}
          >
            <ArrowBackIosNew />
            {t2('Back')}
          </FloatingBackContainer>
          {courseName} {isDraft ? `(${t2('Draft')})` : ''}
        </HeaderContainer>
        <TabPage tabsTitle={tabsTitle} pages={pages} setOpen={setOpen} />
      </Main>
    </Box>
  );
}
